import React from "react";
import { Link } from "react-router-dom";
import { Building2, Store, Hammer, Sparkle, Layers, Check, ArrowRight } from "lucide-react";
import { services } from "@/data/services";
import { Button } from "@/components/ui/button";

const iconMap = { Building2, Store, Hammer, Sparkle, Layers };

export default function Services() {
  return (
    <div className="bg-white">
      <section className="pt-20 md:pt-28 pb-8 md:pb-12">
        <div className="mx-auto max-w-7xl px-6 md:px-10">
          <div className="text-xs uppercase tracking-[0.25em] font-semibold text-[#2196F3] mb-4">Nos services</div>
          <h1 className="font-display text-4xl md:text-6xl font-extrabold tracking-tight text-slate-900 max-w-4xl leading-[1.05]">
            L'excellence du nettoyage professionnel, adaptée à chaque secteur.
          </h1>
          <p className="mt-6 text-lg text-slate-600 max-w-2xl">
            Découvrez notre gamme complète de prestations. Nos équipes interviennent avec méthode, discrétion et matériel professionnel.
          </p>
        </div>
      </section>

      <section className="py-16">
        <div className="mx-auto max-w-7xl px-6 md:px-10 space-y-8">
          {services.map((s, i) => {
            const Icon = iconMap[s.icon] || Sparkle;
            const flip = i % 2 === 1;
            return (
              <div
                key={s.slug}
                data-testid={`service-detail-${s.slug}`}
                className={`grid lg:grid-cols-[1fr_1.2fr] gap-8 items-start bg-slate-50 rounded-3xl p-8 md:p-12 border border-slate-100 ${
                  flip ? "lg:[grid-template-columns:1.2fr_1fr]" : ""
                }`}
              >
                <div className={flip ? "lg:order-2" : ""}>
                  <div className="h-14 w-14 rounded-2xl bg-[#2196F3] flex items-center justify-center mb-6">
                    <Icon className="h-7 w-7 text-white" />
                  </div>
                  <div className="text-xs font-semibold uppercase tracking-[0.25em] text-[#2196F3] mb-3">
                    Prestation {String(i + 1).padStart(2, "0")}
                  </div>
                  <h2 className="font-display text-3xl md:text-4xl font-extrabold text-slate-900 leading-tight">
                    {s.title}
                  </h2>
                  <p className="text-slate-600 mt-4 leading-relaxed">{s.short}</p>
                </div>
                <div className={flip ? "lg:order-1" : ""}>
                  <ul className="space-y-4 bg-white rounded-2xl p-6 md:p-8 border border-slate-100">
                    {s.details.map((d, k) => (
                      <li key={k} className="flex items-start gap-3">
                        <div className="h-6 w-6 rounded-full bg-[#E3F2FD] flex items-center justify-center flex-shrink-0 mt-0.5">
                          <Check className="h-3.5 w-3.5 text-[#2196F3]" strokeWidth={3} />
                        </div>
                        <span className="text-slate-700">{d}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            );
          })}
        </div>
      </section>

      <section className="py-20 md:py-28">
        <div className="mx-auto max-w-6xl px-6 md:px-10">
          <div className="relative overflow-hidden rounded-3xl bg-[#1976D2] p-10 md:p-16 grain">
            <div className="relative z-10 flex flex-col md:flex-row md:items-center md:justify-between gap-8">
              <div>
                <h2 className="font-display text-3xl md:text-4xl font-extrabold text-white leading-tight">
                  Un besoin spécifique ? Nous nous adaptons.
                </h2>
                <p className="text-white/80 mt-4 max-w-xl">
                  Chaque site est unique. Décrivez-nous votre besoin et recevez un devis personnalisé en 24h.
                </p>
              </div>
              <Link to="/devis">
                <Button size="lg" className="rounded-full bg-white text-[#1976D2] hover:bg-[#64B5F6] hover:text-white h-14 px-10 text-base font-semibold">
                  Demander un devis <ArrowRight className="ml-2 h-4 w-4" />
                </Button>
              </Link>
            </div>
            <div aria-hidden className="absolute -bottom-24 -right-24 h-72 w-72 rounded-full bg-[#64B5F6]/30 blur-3xl" />
          </div>
        </div>
      </section>
    </div>
  );
}
